import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";
import CommandeView from "@/features/ventes/components/commandes/CommandeView";

export const Route = createFileRoute("/_app/ventes/commandes/$id/view")({
  staticData: {
    title: "Détails Commande",
    icon: FileText,
    showInBreadcrumb: true,
  },
  component: CommandeView,
});
